import { useResponsive } from '@/hooks/use-responsive';
import { UserProfileDesktop } from './user-profile-desktop';
import { UserProfileMobile } from './user-profile-mobile';

export const UserProfile = () => {
  const { isDesktop } = useResponsive();

  return isDesktop ? <UserProfileDesktop /> : <UserProfileMobile />;
};
